module.exports = __webpack_public_path__ + "img/USA.c0e119e9.png";